import { Building2, QrCode, Banknote, CheckCircle2 } from 'lucide-react';

export const PAYMENT_METHODS = [
  { id: 'bank_transfer', label: 'BANK TRANSFER', icon: Building2 },
  { id: 'upi_qr', label: 'UPI/QR', icon: QrCode },
  { id: 'cash', label: 'CASH', icon: Banknote },
  { id: 'cheque', label: 'CHEQUE', icon: CheckCircle2 },
];

export const PAYMENT_TABS = [
  { id: 'credit', label: 'Credit (Money In)', icon: 'DollarSign' },
  { id: 'follow-up', label: 'Payment Follow-Up', icon: 'MessageSquare' },
];
